import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

interface DonationChartProps {
  donationData: number[]
  donationCategories: string[]
}

const DonationChart = ({ donationData, donationCategories }: DonationChartProps) => {
  const options = {
    chart: {
      type: 'area',
      width: 500,
      height: 185,
    },
    title: {
      text: ''
    },
    xAxis: {
      type: 'category',
      categories: donationCategories
    },
    yAxis: {
      title: {
        text: ''
      }
    },
    series: [{
      name: 'Donation amount',
      data: donationData,
      color: "#FE2F67"
    }],
    credits: {
      enabled: false
    },
    legend:{
      enabled:false
    }
  };

  return (
    <HighchartsReact highcharts={Highcharts} options={options}/>
  );
};

export default DonationChart;
